module.exports = __webpack_public_path__ + "static/media/header_logo.f9eed8ab.svg";